import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { PrimaryButtonContainer } from '../styles';
import { ButtonLabel } from '../shared';
var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "isLoading", "loadingText", "data-test", "type"]);

  if (size === 'xsmall') {
    console.error('Standard button cannot be rendered at size "xsmall". See the spec for more: https://chegg.invisionapp.com/d/main?origin=v7#/console/18294963/380398738/preview?scrollOffset=799');
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement(PrimaryButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    size: size,
    isLoading: isLoading,
    ref: ref,
    type: type
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    isLoading: isLoading,
    size: size,
    loadingText: loadingText
  }, children));
});
Button.displayName = 'Button';
export default Button;